import moment from "moment";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Segment } from "semantic-ui-react";
import { displayDateFormat, fileDataFormat } from "utils/dateFormat";
import messages from "./messages";
import styles from "./styles.module.scss";
import currency from "currency.js";
import { displaySliceId } from "../../utils/sliceFormat";

export interface SummaryProps {
  date: string;
  sliceId: string;
  requirement: string;
  reqChg: string;
  reqPerChg: string;
  highRange: string;
  lowRange: string;
}

const Summary = ({
  date,
  sliceId,
  requirement,
  reqChg,
  reqPerChg,
  highRange,
  lowRange,
}: SummaryProps) => {
  return (
    <div className={styles.header}>
      <Segment raised>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.date} />
        </button>
        <span id="report-date">
          {date ? moment(date, fileDataFormat).format(displayDateFormat) : "-"}
        </span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.slice} />
        </button>
        <span id="report-sliceId">
          {sliceId ? displaySliceId(sliceId) : "-"}
        </span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.req} />
        </button>
        <span id="current-req">
          {isNaN(Number(requirement))
            ? requirement
            : currency(requirement).format()}
        </span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.reqChg} />
        </button>{" "}
        <span id="chg-req">%{reqChg}</span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.rangeHigh} />
        </button>{" "}
        <span id="highRange">{highRange}</span>
        <p></p>
        <button className="ui blue ribbon label">
          <FormattedMessage {...messages.rangeLow} />
        </button>{" "}
        <span id="lowRange">{lowRange}</span>
        <p></p>
      </Segment>
    </div>
  );
};
export default Summary;
